<script lang="ts" setup>
const props = defineProps<{ md: string }>()

const lines = computed(() => props.md.split('\n').map(v => v.trim()).filter(v => v))

const { isH5 } = useDevice()
</script>

<template>
  <div class=" mark-down" :class="isH5 ? 'h5' : 'pc'" v-bind="$attrs">
    <template v-for="v in lines">
      <div v-if="v.startsWith('- ')" class="li">{{ v.replace('- ', '') }}</div>
      <div v-else-if="v.startsWith('# ')" class=" strong">{{ v.replace('# ', '') }}</div>
      <br v-else-if="/\<br(\/)?\>/g.test(v)" />
      <div v-else class=" text-[#000000aa]">{{ v }}</div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.pc {
  .li {
    position: relative;
    font-weight: 900;

    &::before {
      content: '・';
      display: block;
      position: absolute;
      left: -20px;
      font-size: 20px;
      top: 0;
    }
  }

  .strong {
    position: relative;
    font-weight: 900;
  }
}

.h5 {
  .li {
    position: relative;
    font-weight: 900;
    margin-bottom: 1rem;
  }

  .strong {
    position: relative;
    font-weight: 900;
  }
}
</style>
